import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form__field-set" };
const _hoisted_2 = { class: "form__group" };
const _hoisted_3 = { class: "form__label-wrapper" };
const _hoisted_4 = {
    class: "form__label",
    for: "cart-comment"
};
const _hoisted_5 = { class: "form__control-wrapper" };
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartComment',
    props: {
        order: {}
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const comment = ref(props.order.comment || '');
        function onChange() {
            emit('change', comment.value && comment.value.trim());
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", {
                class: "form form--simple cart-comment",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["prevent"]))
            }, [
                _createElementVNode("fieldset", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('order.comment')), 1)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form__control cart-comment__input",
                                maxlength: "1000",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((comment).value = $event)),
                                onChange: onChange
                            }, null, 544), [
                                [_vModelText, comment.value]
                            ])
                        ])
                    ])
                ])
            ], 32));
        };
    }
});
